import { useMemo } from 'react';
import { DataDetailCheckout } from '../types';

type BusinessSettings = {
  primary_color: string;
  secondary_color: string;
  sidebar_text_color: string;
  sidebar_text_secondary_color: string;
  button_color: string;
  button_text_color: string;
  default: string;
  theme_name: string;
};

const DEFAULT_SETTINGS: BusinessSettings = {
  primary_color: '#F5F5F5',
  secondary_color: '#FAFAFA',
  sidebar_text_color: '#111827',
  sidebar_text_secondary_color: '#6b7280',
  button_color: '#5D87FF',
  button_text_color: '#FFFFFF',
  default: '#D9D9D9',
  theme_name: 'Default',
};

export const useBusinessSettings = (
  data: DataDetailCheckout
): BusinessSettings => {
  return useMemo(() => {
    if (!data?.business) return DEFAULT_SETTINGS;

    return {
      primary_color:
        data.business.primary_color ?? DEFAULT_SETTINGS.primary_color,
      secondary_color:
        data.business.secondary_color ?? DEFAULT_SETTINGS.secondary_color,
      sidebar_text_color:
        data.business.sidebar_text_color ?? DEFAULT_SETTINGS.sidebar_text_color,
      sidebar_text_secondary_color:
        data.business.sidebar_text_secondary_color ??
        DEFAULT_SETTINGS.sidebar_text_secondary_color,
      button_color: data.business.button_color ?? DEFAULT_SETTINGS.button_color,
      button_text_color:
        data.business.button_text_color ?? DEFAULT_SETTINGS.button_text_color,
      default: data.business.default ?? DEFAULT_SETTINGS.default,
      theme_name: data.business.theme_name ?? DEFAULT_SETTINGS.theme_name,
    };
  }, [data?.business]);
};
